<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
   export default {
      page: {
         title: "Add Booking",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const datetime = moment().add(1, 'days').format("YYYY-MM-DD") + "T00:00";
         //const datetime = moment().add(1, 'days').format("YYYY-MM-DDThh:mm");
         //const date = moment().format("YYYY-MM-DD HH:mm:ss");
         const date = moment().format("YYYY-MM-DD");



         return {
            title: "Add Booking",
            items: [
               {
                  text: "Booking",
                  href: "/bookings",
               },
               {
                  text: "Add Booking",
                  active: true,
               },        
            ],

            users: [],
            user_visible: false,
            user_keyword: '',
            user_id: "",

            doctors: [],
            doctor_visible: false,
            doctor_keyword: '',
            doctor_id: "",

            clinics: [],

            booking: {
               user_id: "",
               booking_for: "",
               others_name: "",
               others_country_code: 1,
               others_mobile: "",
               others_gender: "",
               others_dob: "",
               doctor_id: "",
               clinic_id: "",    
               booking_datetime: "",
               consultation_preference: "",
               notes: "",
            },

            min_date: date,
            min_datetime: datetime,

            errors: {},

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchCountries();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {
                  this.token = sigomind_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchCountries() {
            let url = "api/general/countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         closeUserSearch() {
            this.user_visible = false;
            this.user_keyword = '';
            this.user_id = "";

         },

         setUser() {
            this.user_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.user_visible = false;
         },

         fetchUsers() { 
            let url = "admin/get-users?keyword=" + this.user_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.users = responseData.users;

               })
               .catch((err) => console.log(err));
            this.user_visible = true;  
         },


         closeDoctorSearch() {
            this.doctor_visible = false;
            this.doctor_keyword = '';
            this.doctor_id = "";
            this.clinics = [];
         },

         setDoctor() {
            this.doctor_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.doctor_visible = false;
            this.fetchDoctorClinics();
         },

         fetchDoctors() {  
            let url = "admin/get-doctors?keyword=" + this.doctor_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors;

               })
               .catch((err) => console.log(err));
            this.doctor_visible = true;   
         },

         fetchDoctorClinics() {  
            let url = "admin/get-doctor-clinics?doctor_id=" + this.doctor_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinics = responseData.doctor.clinics;

               })
               .catch((err) => console.log(err));
         },

         addBooking() {
            this.getToken();            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let formData = new FormData();
            formData.append("user_id", this.user_id);            
            formData.append("booking_for", this.booking.booking_for);
            formData.append("others_name", this.booking.others_name);
            formData.append("others_country_code", this.booking.others_country_code);
            formData.append("others_mobile", this.booking.others_mobile);
            formData.append("others_gender", this.booking.others_gender);
            formData.append("others_dob", this.booking.others_dob);
            formData.append("doctor_id", this.doctor_id);
            formData.append("clinic_id", this.booking.clinic_id);
            formData.append("consultation_preference", this.booking.consultation_preference);
            formData.append("notes", this.booking.notes);            

            let datetime = moment.utc(this.booking.booking_datetime).format("YYYY-MM-DD HH:mm:ss");
            formData.append("booking_datetime", datetime);         
        
            let url = 'admin/bookings/add';
                   
            this.loading = true;

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }

                     this.$router.push({ name: 'bookings'});
               })
               .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'bookings' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addBooking()">
                        <div class="row"> 

                           <b-form-group class="col-lg-6">
                              <label>User <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="user_visible" @click="closeUserSearch"><i class="dripicons dripicons-cross"></i></span>
                                       
                                 <b-form-input v-model="user_keyword"  @keyup="fetchUsers()"  autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.user_id) }"></b-form-input>
                                 
                                 <b-form-select v-if="user_visible && Boolean(users.length)" class="form-control" v-model="user_id" :select-size="users.length < 10 ? (users.length <= 1 ? 2 : users.length) : 10" @change="setUser">
                                    <b-form-select-option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }} | {{user.converted_mobile}} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select v-if="user_visible && !Boolean(users.length)" class="form-control" v-model="user_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>

                                 
                              </div>
                              <div v-for="(val, index) in errors.user_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>

                           <b-form-group class="col-lg-6">
                              <label>Booking for <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="booking.booking_for" v-bind:class="{ 'is-invalid': Boolean(errors.booking_for) }">
                                 <option value="">Select</option>
                                 <option value="1">Self</option>
                                 <option value="2">Others</option>
                              </select>

                              <div v-for="(val, index) in errors.booking_for" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>

                           <div class=" col-12 mt-3 mb-2" v-if="booking.booking_for=='2'" >

                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="card-title mb-3">Patient Details</h4>
                                 <div class="row">

                                    <b-form-group class="col-lg-6">
                                       <label>Patient Name <span class="text-danger">*</span></label>
                                       <b-form-input v-model="booking.others_name" v-bind:class="{ 'is-invalid': Boolean(errors.others_name) }"></b-form-input>

                                       <div v-for="(val, index) in errors.others_name" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div> 
                                    </b-form-group>

                                    <b-form-group class="col-lg-6">
                                       <label>Mobile <span class="text-danger">*</span></label>
                                       <b-input-group v-bind:class="{ 'is-invalid': Boolean(errors.others_country_code) || Boolean(errors.others_mobile) }">
                                          <b-input-group-prepend>
                                             <select class="form-control" v-model="booking.others_country_code">
                                                <option :value="country.id" v-for="country in countries" :key="country.id">{{country.code}}</option>
                                             </select>
                                          </b-input-group-prepend>
                                          <b-form-input v-model="booking.others_mobile" v-bind:class="{ 'is-invalid': Boolean(errors.user_id) }"></b-form-input>
                                       </b-input-group>

                                       <div v-for="(val, index) in errors.others_country_code" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div> 
                                       <div v-for="(val, index) in errors.others_mobile" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div> 
                                    </b-form-group>                           

                                    <b-form-group class="col-lg-6">
                                       <label>Date of Birth <span class="text-danger">*</span></label>
                                       <input type="date" v-model="booking.others_dob" class="form-control" :max="min_date"  v-bind:class="{ 'is-invalid': Boolean(errors.others_dob) }"/>

                                       <div v-for="(val, index) in errors.others_dob" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div> 
                                    </b-form-group>

                                    <b-form-group class="col-lg-6">
                                       <label>Gender <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="booking.others_gender" v-bind:class="{ 'is-invalid': Boolean(errors.others_gender) }">
                                          <option value="">Select</option>
                                          <option value="1">Male</option>
                                          <option value="2">Female</option>
                                          <option value="3">Other</option>
                                       </select>

                                       <div v-for="(val, index) in errors.others_gender" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div> 
                                    </b-form-group>
                                 </div>

                              </b-card>
                           </div>

                           <b-form-group class="col-lg-6">
                              <label>Doctor <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="doctor_visible" @click="closeDoctorSearch"><i class="dripicons dripicons-cross"></i></span>
                                       
                                 <!-- <b-form-input v-model="doctor_keyword"  @keyup="fetchDoctors()"  autocomplete="off" placeholder="Search here..."></b-form-input> -->
                                 
                                 <b-form-input v-model="doctor_keyword"  @keyup="fetchDoctors()"  autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }"></b-form-input>
                                
                                 
                                 <b-form-select v-if="doctor_visible && Boolean(doctors.length)" class="form-control" v-model="doctor_id" :select-size="doctors.length < 10 ? (doctors.length <= 1 ? 2 : doctors.length) : 10" @change="setDoctor">
                                    <b-form-select-option v-for="doctor in doctors" :key="doctor.id" :value="doctor.id">{{ doctor.doctor_name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select v-if="doctor_visible && !Boolean(doctors.length)" class="form-control" v-model="doctor_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                              </div>
                              <div v-for="(val, index) in errors.doctor_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>

                           <b-form-group class="col-lg-6">
                              <label>Clinic <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="booking.clinic_id" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                 <option value="">Select</option>
                                 <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">{{clinic.clinic_name}}</option>
                              </select>

                              <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>

                           <b-form-group class="col-lg-6">
                              <label>Date and Time <span class="text-danger">*</span></label>
                             <b-form-input type="datetime-local" v-model="booking.booking_datetime" v-bind:class="{ 'is-invalid': Boolean(errors.booking_datetime) }" :min="min_datetime"></b-form-input>

                             <div v-for="(val, index) in errors.booking_datetime" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>

                           <b-form-group class="col-lg-6">
                              <label>Consultation Preference <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="booking.consultation_preference" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_preference) }">
                                 <option value="">Select</option>
                                 <option value="1">Offline</option>
                                 <option value="2">Online</option>
                              </select>

                              <div v-for="(val, index) in errors.consultation_preference" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>
                           
                        </div>

                        <div class="row">
                           <b-form-group class="col-lg-12">
                              <label>Notes</label>
                              <b-form-textarea rows="3" v-model="booking.notes" v-bind:class="{ 'is-invalid': Boolean(errors.notes) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.notes" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> 
                           </b-form-group>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'bookings' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
